import React from 'react';
import { useRequestServiceModalContext } from '@/finsight/application/RequestServiceModalContext';
import { ServiceType } from '@/finsight/domain/ServiceType';
import RequestQuotePanel from '../RequestQuotePanel';

import api from '../assets/api.svg';

const ApiIntegrationPanel = () => {
  const { openModal } = useRequestServiceModalContext();

  return (
    <RequestQuotePanel
      imgUrl={ api }
      imgAlt="Finsight.com Market Data API"
      title="Finsight.com Market Data API"
      description={ (
        <>
          <span>Aggregate or reconstruct tranche and deal-level pricing details from the most accurate and</span>
          <br/>
          <span>comprehensive ABS and corporate bond new issue pricing data.</span>
        </>
      ) }
      dataTest="pricingApi"
      onButtonClick={ () => openModal(ServiceType.API) }
    />
  );
};

export default ApiIntegrationPanel;
